import { render, staticRenderFns } from "./DocumentDashboardTotals.vue?vue&type=template&id=34f58af4&scoped=true"
import script from "./DocumentDashboardTotals.vue?vue&type=script&lang=js"
export * from "./DocumentDashboardTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f58af4",
  null
  
)

export default component.exports